"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryCode = void 0;
var CountryCode;
(function (CountryCode) {
    CountryCode["Germany"] = "DE";
    CountryCode["Austria"] = "AT";
    CountryCode["Switzerland"] = "CH";
    CountryCode["Netherlands"] = "NL";
    CountryCode["France"] = "FR";
    CountryCode["Luxembourg"] = "LU";
    CountryCode["Spain"] = "ES";
    CountryCode["Italy"] = "IT";
    CountryCode["Belgium"] = "BE";
    CountryCode["Liechtenstein"] = "LI";
    CountryCode["GreatBritan"] = "GB";
})(CountryCode = exports.CountryCode || (exports.CountryCode = {}));
//# sourceMappingURL=country-code.js.map